<template>
	<fragment>
		<common-header
			subname="상담관리"
			name="상담 목록"
			v-bind:searchbox="true"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:initKeyword="keyword"
			@keywordChanged="searchByKeyword"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav"></nav>

			<div class="container-fiuld clearfix" v-if="selectedBoard">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{selectedBoard.boardName}}
					</div>
				</div>
				<div class="btn-group-box clearfix">
					<!--div class="btn-group pull-left clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn btn-red round" href="#" onclick="$('#plus-modal').show()">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
									<path class="recycle"
										d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
										transform="translate(-502.5 -1247)"></path>
								</svg> 삭제
							</a>
						</div>
					</div-->
					<!-- //end .btn-group -->
					<!-- //end .btn-group -->
					<table class="table2 table-hover text-center">
						<thead>
							<tr class="bg-lightgray">
								<!--th>
									<input id="table-allcheck" class="checkbox" type="checkbox" :checked="allSelected" @change="selectAll">
									<label for="table-allcheck">체크버튼</label>
								</th-->
								<th>#</th>
								<th>분류</th>
								<th>제목</th>
								<th>작성자</th>
								<th>작성일</th>
								<th>조회수</th>
								<th>처리상태</th>
							</tr>
						</thead>
						<tbody v-for="(article, idx) in articles" :key="`article-id-${article.articleId}`">
							<tr class="margin">
								<td colspan="7"></td>
							</tr>
							<tr>
								<!--td>
									<input :id="`article-check-${hash(article)}`" class="checkbox" type="checkbox" v-model="article.selected">
									<label :for="`article-check-${hash(article)}`">체크버튼</label>
								</td-->
								<td>
									{{totalCount - offset - idx}}
								<td>
									{{article.articleCategoryId?article.articleCategoryNm:"미분류"}}
								</td>
								<td style="text-align: left;" @click="$router.push(`/counsel/${article.boardId}/detail/${article.articleId}${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`)">
									<span v-for="(i, idx) in new Array(article.depth?article.depth:0)" :key="'space-for-'+article.articleId+'-'+idx">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
									<span v-if="article.depth>0">[답글]</span> {{article.title}}
								</td>
								<td>
									{{article.mber && article.mber.mberName || article.name}}
								</td>
								<td>
									{{article.regDate}}
								</td>
								<td>
									{{article.lookupCount}}
								</td>
								<td>
									{{article.replyCount ? "답변완료" : "대기중"}}
								</td>
							</tr>
						</tbody>
					</table>

					<ctrl-pagination :currentPage="offset / pageSize + 1"
						:pageSize="pageSize" :totalCount="totalCount"
						:key="hash({pageSize, offset, totalCount})"
						@pageChanged="onPageChanged"></ctrl-pagination>
				</div>
			</div>
		</section>

		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명칭
	name: "ViewBoardList",
	mixins: [fnAdjustHeight],
	mounted: function() {
		this.getBoardList();
		this.getArticles();
		this.getAuthInfo().then((auth) => {
			if(auth['관리자 권한']['상담관리: 상담 등록'] && auth['관리자 권한']['상담관리: 상담 등록']['permission']) {
				this.buttons = [
					...this.buttons, 
					{name: '상담글 작성', fn: () => {
						this.$router.push(`/counsel/${server.counselBoardId}/write`);
					}},
				];
			}

			if(auth['관리자 메뉴']['상담관리']) {
				if(auth['관리자 메뉴']['상담관리']['상담글 목록'] && auth['관리자 메뉴']['상담관리']['상담글 목록']['enabled']) {
					this.menus = [
						...this.menus,
						{name:'상담글 목록',link:"/counsel",selected:true}
					];
				}
				if(auth['관리자 메뉴']['상담관리']['상담 통계'] && auth['관리자 메뉴']['상담관리']['상담 통계']['enabled']) {
					this.menus = [
						...this.menus,
						{name:"상담통계", link:"/counselStatistics",selected:false}
					];
				}
			}

		});
	},
	// 이 컴포넌트에서 사용할 자식컴포넌트
	components: {
		CommonHeader,
		CommonFooter,
		CtrlPagination,
		ModalConfirm,
		ModalAlert
	},

	// 이 컴포넌트에서 사용할 내부데이터
	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},
			menus: [],
			buttons: [],
			auth: {},
			sideButtons: [],
			sideMenus: [],
			selectedBoard: null,
			articles: [],
			keyword: this.$route.query.keyword || "",
			totalCount: 0,
			pageSize: parseInt(this.$route.query.pageSize) || 30,
			offset: parseInt(this.$route.query.offset) || 0,
		}
	},

	// 이 컴포넌트에서 구현할 기능
	methods: {
		getBoardList: async function() {
			try {
				const {data} = await Axios.post(`${server.addr()}${server.api.BOARD}`, { lecId: 0, pageSize: 500 })
				let boardId = server.counselBoardId;
				data.list.some(e => {
					if(e.boardId === parseInt(boardId)) {
						this.selectedBoard = e;
						return true;
					}
				});
			} catch(e) {e}
		},
		getArticles: async function() {
			try {
				const { keyword, offset, pageSize } = this;
				const boardId = server.counselBoardId;
				if(!boardId) return;
				
				const { data } = await Axios.post(`${server.addr()}${server.api.ARTICLE}`, {
					boardId, pageSize, offset, keyword, parentsId:0
				});
				this.articles = data.list.map(e=>{ e["selected"] = false; return e; });
				this.totalCount = parseInt(data.filtered);
			} catch(e) {
				// TODO : error exception
			}
		},
		searchByKeyword: function(keyword) {
			const { pageSize } = this;
			this.offset = 0;
			this.keyword = keyword;
			this.$router.replace({ query: {offset: this.offset, pageSize, keyword} });
			this.getArticlList();
		},
		selectAll: function() {
			const targetBool = !this.articles.reduce((prev, curr) => prev && curr.selected , true);
			this.articles.forEach(art=>{
				art.selected = targetBool;
			});
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;
			this.$router.replace({ query: {offset: this.offset, pageSize} });
			this.getArticles();
		},
	},
	computed: {
		allSelected: function() {
			const isAllSelected = this.articles.reduce((prev, curr) => prev && curr.selected , true);
			return isAllSelected;
		}
	}
}
</script>

<style scoped>
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}

.btn-group .btn:hover .recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>
